import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationItamsConstants {
    static STEP_TITLE = "Location";
    static REMOVE_BAY_LABEL = "Remove bay";
    static LAYER_REF = "ITAMS graphics";
    static DESCRIPTION_LABEL_1 = "Search the map to find the bay for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct bay and click on the bay. Click on 'add bay' in the window that appears on the map after you selected the bay.";
    static DESCRIPTION_LABEL_3 = "The bay will be added and the fields must be completed for the bay. Please note that multiple bays may be added.";
    static BAY_REQUIRED = "Please select a bay before saving or continuing with the application process";
    static CLEARED_VALIDATION_MESSAGE = "Form cannot be cleared after previous application has been validated.";
    static ADDRESS_CONTROL = "address";
    static BAY_NUMBER_CONTROL = "bayNumber";
    static BAY_SIZE_CONTROL = "baySize";
    static BAYS_FORM_CONTROL = "bays";
    static BAYS_FORM_GROUP_NAME = "baysForm";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static BAY_NUMBER_PLACEHOLDER = "Bay number";
    static BAY_SIZE_TEXT_PLACEHOLDER = "Bay size";
    static DUPLICATE_MESSAGE = "The selected bay has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the bay zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, bayNumber: {
            required: `Bay number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, baySize: {
            required: `Bay size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
